import React, { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { BasePopup, Button, Label } from '@atlas/ui';

import { isFunction } from 'common/utils';

const DetailedPopup = props => {
  const {
    data = {},
    id,
    // status,
    title,
  } = props;
  const { children, className, confirmLabel = 'confirm' } = data;

  const onConfirmHandler = useCallback(() => {
    if (isFunction(data.onConfirm)) {
      data.onConfirm();
    }

    NotificationManager.removeNotification(id);
  }, []);

  return (
    <BasePopup className={cx('transaction-detail-popup', className)}>
      <div className="popup__content">
        {title && <Label className="popup__title" message={title} />}
        {children}
      </div>

      <div className="popup__footer">
        <div className="popup__buttons">
          <Button className="primary block" label={confirmLabel} onClick={onConfirmHandler} />
        </div>
      </div>
    </BasePopup>
  );
};

DetailedPopup.propTypes = {
  data: PropTypes.shape({
    children: PropTypes.node,
    className: PropTypes.string,
    confirmLabel: PropTypes.string,
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
};

export default DetailedPopup;
